import Dexie from "dexie";

// IndexedDB database for offline-first caching and sync queue.
// Version history: bump version and add upgrade block when changing stores/indexes.
export const db = new Dexie("AskualaStaffDB");

db.version(1).stores({
  // Generic key-value cache: { key, data, updatedAt }
  // key examples: 'attendance-students:staff123', 'result-students:staff123'
  cache: "key, updatedAt",

  // Attendance submissions queued while offline: { id, payload, date, class, status, createdAt }
  // status: 'pending' | 'syncing'
  attendanceQueue: "++id, status, createdAt",
});

export default db;
